export default __webpack_public_path__ + "static/media/gallery_01.41019bb3.jpg";